<template>
  <a
    class="listItem"
    :href="href"
    :target="isOpenBlank ? '_blank' : ''"
    :rel="isOpenBlank ? 'noopener' : ''"
    @click="clickItem"
  >
    <p class="listItem_ttl">{{ text }}</p>
    <ul v-if="isShowlabels">
      <HospitalLabel :items="labels" />
    </ul>
  </a>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'

export default defineComponent({
  components: {
    HospitalLabel
  },

  props: {
    text: {
      type: String,
      required: true
    },
    href: {
      type: String
    },
    isOpenBlank: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Array as PropType<string[]>
    },
    isShowlabels: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    const clickItem = (e: any) => {
      if (props.isOpenBlank || e.ctrlKey || e.metaKey) return true

      e.preventDefault()
      emit('click-item')
    }

    return {
      clickItem
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.listItem {
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  display: block;
  border-bottom: 1px solid var.$color-border-gray;
  position: relative;

  &:after {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid var.$color-main;
    border-bottom: 2px solid var.$color-main;
    transform: rotate(-45deg) translateY(-1px);
    margin-left: 4px;
    position: absolute;
    right: 0;
    top: calc(50% - 4px);
  }

  &_ttl {
    font-size: 1.8rem;
    font-weight: 500;
    margin-top: -4px;
    margin-bottom: 6px;
    padding-right: 20px;
    line-height: 1.5;

    @include mixins.media() {
      font-size: 1.4rem;
    }
  }
}
</style>
